import React, { useState, useEffect } from 'react';
import './footer.scss';
import LOGO_BIG from '../assets/logo_big.png';
import POLICE_IMG from '../assets/police.png';
import { useHistory, useLocation, useParams } from 'react-router-dom';
const map = Object.freeze({
  a: {
    en: 'Home',
    'zh-cn': '首页',
  },
  b: {
    en: 'Product Center',
    'zh-cn': '产品中心',
  },
  c: {
    en: 'News',
    'zh-cn': '新闻资讯',
  },
  d: {
    en: 'About Fantai',
    'zh-cn': '关于钒泰',
  },
  e: {
    en: 'Contact Us',
    'zh-cn': '联系我们',
  },
});

const Footer = () => {
  const history = useHistory();
  const location = useLocation();

  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');

  const toAbout = () => history.push('/' + la + '/about');
  const toHome = () => history.push('/' + la);
  const toProduct = () => history.push('/' + la + '/product');
  const toNews = () => history.push('/' + la + '/news');
  const toContact = () => history.push('/' + la + '/contact');

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='footer-content'>
          <ul className='footer-menu'>
            <li className='footer-sub-menu' onClick={toProduct}>
              {map.b[la]}
            </li>

            <li className='footer-sub-menu' onClick={toNews}>
              {map.c[la]}
            </li>
            <li className='footer-sub-menu' onClick={toAbout}>
              {map.d[la]}
            </li>
            <li className='footer-sub-menu' onClick={toContact}>
              {map.e[la]}
            </li>
          </ul>
          <div className='footer-about'>
            <div className='copyright'>@2020 山东钒泰精化生物科技有限公司 版权所有</div>
            <div className='record-rights'>
              <a
                className='police-record-no'
                href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37079002000105'
                target='_blank'
              >
                鲁公网安备 37079002000105号
              </a>
              <div className='police-img'>
                <img src={POLICE_IMG} alt='' />
              </div>
              <a href='http://www.beian.miit.gov.cn' target='_blank' className='icp-record-no'>
                ICP备案号： 鲁ICP备20014792号
              </a>
            </div>
          </div>
        </div>
        <div className='footer-logo' onClick={toHome} placeholder='山东钒泰精化生物科技有限公司'>
          <img src={LOGO_BIG} alt='钒泰精化' />
        </div>
      </div>

      <div className='side-bar'>
        <div className='img-wechat img'>
          <div></div>
        </div>
        <div className='img-phone img'>
          <div></div>
        </div>
        <a href='tencent://message/?uin=3007939906&Site=Sambow&Menu=yes' className='img-qq img'>
          <div></div>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
